import { render, staticRenderFns } from "./center-shifter.vue?vue&type=template&id=62cc4420&"
import script from "./center-shifter.vue?vue&type=script&lang=js&"
export * from "./center-shifter.vue?vue&type=script&lang=js&"
import style0 from "./_center-shifter.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports